/* jshint browser:true,curly: false */
/* global L */

/* jshint browser:true,curly: false */
/* global L */

import DrawRectangle from 'mapbox-gl-draw-rectangle-mode';
import { v4 as uuidv4 } from 'uuid';

import markerPicture from './img/marker.png';

window.onload = () => {
    window.vue = new Vue({
        el: '#app',
        components: {
            Multiselect: window.VueMultiselect.default
        },
        data: {
            credentials: {
                production: {
                    listCategoriesUrl: 'https://api.mapbox.com/search/searchbox/v1/list/category',
                    unifiedCategoryUrl: 'https://api.mapbox.com/search/searchbox/v1/category',
                    unifiedSuggestUrl: 'https://api.mapbox.com/search/searchbox/v1/suggest',
                    unifiedRetrieveUrl: 'https://api.mapbox.com/search/searchbox/v1/retrieve',
                    unifiedReverseUrl: 'https://api.mapbox.com/search/searchbox/v1/reverse',
                    key_federation: 'pk.eyJ1Ijoic2VhcmNoLW1hY2hpbmUtdXNlci0xIiwiYSI6ImNrNnJ6bDdzdzA5cnAza3F4aTVwcWxqdWEifQ.RFF7CVFKrUsZVrJsFzhRvQ'
                },
                map: {
                    key: 'pk.eyJ1Ijoic2JtYTQ0IiwiYSI6ImNpcXNycTNqaTAwMDdmcG5seDBoYjVkZGcifQ.ZVIe6sjh0QGeMsHpBvlsEA'
                },
            },

            // If the page is just loaded and has a query in the hash value,
            // zoom the map to the bbox extent of the results
            fitZoom: false,
            bbox: { type: 'FeatureCollection', features: [] },
            query: '',
            url: '',
            urlview: false, //Show URL in settings panel
            saved: [],
            suggestResults: [],
            // Results from forward or reverse geocoding queries
            geocoderResults: { type: 'FeatureCollection', features: [] },
            jsonResponse: {},
            // Results from querying vector tiles
            languages: [
                // { code: 'ar', name: 'Arabic' },
                // { code: 'az', name: 'Azerbaijani' },
                { code: 'be', name: 'Belarusian' },
                // { code: 'bg', name: 'Bulgarian' },
                // { code: 'bn', name: 'Bengali' },
                // { code: 'bs', name: 'Bosnian' },
                // { code: 'ca', name: 'Catalan' },
                { code: 'cs', name: 'Czech' },
                { code: 'da', name: 'Danish' },
                { code: 'de', name: 'German' },
                { code: 'el', name: 'Greek' },
                { code: 'en', name: 'English' },
                { code: 'es', name: 'Spanish' },
                { code: 'et', name: 'Estonian' },
                // { code: 'fa', name: 'Persian' },
                { code: 'fi', name: 'Finnish' },
                { code: 'fr', name: 'French' },
                // { code: 'gu', name: 'Gujarati' },
                // { code: 'he', name: 'Hebrew' },
                // { code: 'hi', name: 'Hindi' },
                { code: 'hr', name: 'Croatian' },
                { code: 'hu', name: 'Hungarian' },
                // { code: 'id', name: 'Indonesian' },
                // { code: 'is', name: 'Icelandic' },
                { code: 'it', name: 'Italian' },
                // { code: 'ja', name: 'Japanese' },
                // { code: 'ka', name: 'Georgian' },
                // { code: 'kk', name: 'Kazakh' },
                // { code: 'kn', name: 'Kannada' },
                // { code: 'ko', name: 'Korean' },
                { code: 'lt', name: 'Lithuanian' },
                { code: 'lv', name: 'Latvian' },
                // { code: 'mk', name: 'Macedonian' },
                // { code: 'mn', name: 'Mongolian' },
                // { code: 'ms', name: 'Malay' },
                // { code: 'mt', name: 'Maltese' },
                // { code: 'nb', name: 'Norwegian Bokmål' },
                { code: 'nl', name: 'Dutch' },
                // { code: 'no', name: 'Norwegian' },
                { code: 'pl', name: 'Polish' },
                { code: 'pt', name: 'Portuguese' },
                { code: 'ro', name: 'Romanian' },
                { code: 'ru', name: 'Russian' },
                // { code: 'si', name: 'Sinhala' },
                { code: 'sk', name: 'Slovak' },
                { code: 'sl', name: 'Slovenian' },
                // { code: 'sq', name: 'Albanian' },
                { code: 'sr', name: 'Serbian' },
                { code: 'sv', name: 'Swedish' },
                // { code: 'ta', name: 'Tamil' },
                // { code: 'te', name: 'Telugu' },
                // { code: 'tg', name: 'Tajik' },
                // { code: 'th', name: 'Thai' },
                // { code: 'tk', name: 'Turkmen' },
                // { code: 'tl', name: 'Tagalog' },
                { code: 'tr', name: 'Turkish' },
                { code: 'uk', name: 'Ukrainian' },
                // { code: 'ur', name: 'Urdu' },
                // { code: 'uz', name: 'Uzbek' },
                // { code: 'vi', name: 'Vietnamese' },
                // { code: 'zh', name: 'Chinese' }
            ],
            countries: [
                {code: 'AA', name: 'Any'},
                {code: 'US', name: 'United States'},
                {code: 'AD', name: 'Andorra'},
                {code: 'AL', name: 'Albania'},
                {code: 'AT', name: 'Austria'},
                {code: 'AZ', name: 'Azerbaijan'},
                {code: 'BA', name: 'Bosnia and Herzegovina'},
                {code: 'BE', name: 'Belgium'},
                {code: 'BG', name: 'Bulgaria'},
                {code: 'BY', name: 'Belarus'},
                {code: 'CH', name: 'Switzerland'},
                {code: 'CY', name: 'Cyprus'},
                {code: 'CZ', name: 'Czech Republic'},
                {code: 'DE', name: 'Germany'},
                {code: 'DK', name: 'Denmark'},
                {code: 'EE', name: 'Estonia'},
                {code: 'ES', name: 'Spain'},
                {code: 'FI', name: 'Finland'},
                {code: 'FO', name: 'Faroe Islands'},
                {code: 'FR', name: 'France'},
                {code: 'GB', name: 'United Kingdom'},
                {code: 'GE', name: 'Georgia'},
                {code: 'GI', name: 'Gibraltar'},
                {code: 'GL', name: 'Greenland'},
                {code: 'GR', name: 'Greece'},
                {code: 'HR', name: 'Croatia'},
                {code: 'HU', name: 'Hungary'},
                {code: 'JP', name: 'Japan'},
                {code: 'IE', name: 'Ireland'},
                {code: 'IS', name: 'Iceland'},
                {code: 'IT', name: 'Italy'},
                {code: 'KZ', name: 'Kazakhstan'},
                {code: 'KG', name: 'Kyrgyzstan'},
                {code: 'LI', name: 'Liechtenstein'},
                {code: 'LT', name: 'Lithuania'},
                {code: 'LU', name: 'Luxembourg'},
                {code: 'LV', name: 'Latvia'},
                {code: 'MD', name: 'Moldova'},
                {code: 'MC', name: 'Monaco'},
                {code: 'ME', name: 'Montenegro'},
                {code: 'MK', name: 'North Macedonia'},
                {code: 'MT', name: 'Malta'},
                {code: 'NL', name: 'Netherlands'},
                {code: 'NO', name: 'Norway'},
                {code: 'PL', name: 'Poland'},
                {code: 'PT', name: 'Portugal'},
                {code: 'RO', name: 'Romania'},
                {code: 'RS', name: 'Serbia'},
                {code: 'RU', name: 'Russia'},
                {code: 'SE', name: 'Sweden'},
                {code: 'SI', name: 'Slovenia'},
                {code: 'SG', name: 'Singapore'},
                {code: 'SJ', name: 'Svalbard and Jan Mayen'},
                {code: 'SK', name: 'Slovakia'},
                {code: 'SM', name: 'San Marino'},
                {code: 'TJ', name: 'Tajikistan'},
                {code: 'TM', name: 'Turkmenistan'},
                {code: 'UZ', name: 'Uzbekistan'},
                {code: 'VA', name: 'Vatican City'},
                {code: 'XK', name: 'Kosovo'},
            ],
            tabs: [
                "Settings",
                "Request",
                "Response"
            ],
            categories: [],
            layers: [],
            defaultCnf: '', //Stores a stringified version of below for resetting to default state
            cnf: {
                onType: true,
                onProximity: true,
                onLimit: true,
                onLanguage: true,
                onCountry: true,
                onToken: false,
                proximity: '',
                //type: 'unified',
                typeToggle: {
                    'country': true,
                    'region': true,
                    'district': true,
                    'postcode': true,
                    'locality': true,
                    'place': true,
                    'neighborhood': true,
                    'address': true,
                    'poi': true,
                    'street': true,
                    'category': true
                },
                types: [
                    'country',
                    'region',
                    'district',
                    'postcode',
                    'locality',
                    'place',
                    'neighborhood',
                    'address',
                    'poi',
                    'street',
                    'category'
                ],
                limit: '10',
                language: {},
                country: {},
                category: [],
                token: '',
                onCategories: true
            },
            activeTab: 'Settings',
            hostname: location.hostname,
            getlocation: false,
            searchTime: new Date(),
            sessionId: uuidv4(),
            // in compactMode don't show settings panel and header icons
            // default to true to avoid blinking
            compactMode: true,
            selectedCategory: undefined,
            categoryDropdownShown: false,
            settingsPanelOpened: false,
        },

        // Called synchronously after the Vue instance is created https://vuejs.org/v2/api/#created
        created: function() {
            // this.defaultCnf = Object.keys(this.cnf).map(key => key + '=' + this.cnf[key]).join('&');
            // let saved = localStorage.getItem('saved');
            // if (saved) this.saved = JSON.parse(saved);
            // // Set state to search value
            // if (window.location.search) {
            //     let urlParams = new URLSearchParams(window.location.search)
            //     if (urlParams.get('query')) this.query = urlParams.get('query');
            //     urlParams.forEach((v, k) => {
            //       v = v ? v : this.cnf[k];
            //       this.cnf[k] = v;
            //     })
            // }
            this.defaultCnf = JSON.stringify(this.cnf);

            // calculate compactMode
            const urlParams = new URLSearchParams(window.location.search);
            const mode = urlParams.get('mode');
            this.compactMode = mode === 'compact.'; 

            // Set state to hashed value
            if (window.location.hash) {
                this.fitZoom = true;
                let cnf = JSON.parse(decodeURIComponent(window.location.hash.substring(1, window.location.hash.length)));
                // Populate the query form separately from other cnf properties
                // query is part of the Vue's data property, not the cnf
                this.query = cnf.query;
                delete cnf.query;

                for (let c in cnf) {
                    this.cnf[c] = cnf[c];
                }
            }
        },
        // Called after the instance has been mounted-- now ready to add map
        mounted: function() {
            this.$nextTick(function() {
                ///?????
                (typeof this.cnf.language === 'object') ? this.setLanguage(navigator.language.split('-')[0]) : this.setLanguage(this.cnf.language);
                (typeof this.cnf.language === 'object') ? this.setCountry('AA') : this.setCountry(this.cnf.country);

                mapboxgl.accessToken = this.credentials.map.key;
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox-search-web/ckvsj8zh613el14qdcpvvhmd0',
                    center: [-98, 40],
                    zoom: 3
                });

                const nav = new mapboxgl.NavigationControl({
                    showCompass: false
                });
                this.map.addControl(nav);       
                
                const bboxDrawModes = MapboxDraw.modes;
                bboxDrawModes.draw_rectangle = DrawRectangle;

                this.draw = new MapboxDraw({
                    modes: bboxDrawModes,
                    defaultMode: 'draw_rectangle',
                    displayControlsDefault: false
                });

                this.geocoder = new MapboxGeocoder({
                    accessToken: this.credentials.map.key,
                    types: 'neighborhood,locality,place,district,postcode'
                });

                this.geocoder.addTo('#geocoder');
                this.geocoder.on('result', (e) => {
                    this.cnf.proximity = e.result.geometry.coordinates.join(',');
                    this.setProximity();
                })

                this.map.on('style.load', () => {
                    this.map.addSource('markers', { type: 'geojson', data: this.geocoderResults });
                    this.map.addSource('bbox', { type: 'geojson', data: this.bbox });

                    for (let src of ['selected', 'hovered', 'hovered-bbox', 'debug']) {
                        this.map.addSource(src, { 'type': 'geojson', 'data': { 'type': 'FeatureCollection', 'features': [] } });
                    }

                    this.map.loadImage(markerPicture, (error, image) => {
                        if (error) throw error;
                        this.map.addImage('custom-marker', image);
                    });

                    // Add a symbol layer
                    this.map.addLayer({
                        'id': 'points',
                        'type': 'symbol',
                        'source': 'markers',
                        paint: {
                            "text-color": "white",
                        },
                        'layout': {
                            'icon-image': 'custom-marker',
                            // get the title name from the source's "title" property
                            'text-field': ['get', 'lower_id'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, -0.15],
                            'text-anchor': 'center'
                        }
                    });

                    this.map.addLayer({ 'id': 'selected', 'source': 'selected', 'type': 'circle', 'paint': { 'circle-radius': 10, 'circle-color': '#990000' } });
                    this.map.addLayer({ 'id': 'hovered', 'source': 'hovered', 'type': 'circle', 'paint': { 'circle-radius': 10, 'circle-color': '#0f9900' } });
                    this.map.addLayer({ 'id': 'hovered-bbox', 'source': 'hovered-bbox', 'type': 'line', 'paint': { 'line-width': 2, 'line-color': '#0f9900' } });
                    this.map.addLayer({ 'id': 'debug', 'source': 'debug', 'type': 'circle', 'paint': { 'circle-radius': 10, 'circle-color': '#000000' } });
                    this.map.addLayer({ 'id': 'bbox', 'source': 'bbox', 'type': 'fill', 'paint': { 'fill-color': '#273d56', 'fill-opacity': 0.5 } });
                });

                this.cnf.proximity ? this.setProximity() : this.setCurrentPositionProximity();

                this.search();

                this.map.on('load', () => {
                    // Add watch functions that trigger map events
                    // after map has been loaded to avoid GL JS errors
                    // Trigger the watch functions immediately

                    const scale = new mapboxgl.ScaleControl({
                        maxWidth: 58,
                        unit: 'metric'
                    });
                    this.map.addControl(scale);

                    this.$watch('geocoderResults.features', function() {
                        this.setMarkers('markers', this.geocoderResults);
                    }, { immediate: true });

                    this.$watch('bbox', function() {
                        this.setMarkers('bbox', this.bbox);
                    }, { immediate: true });

                });

                this.fetchCategories();
            });
        },
        // watch functions are triggered by user interactions which change values in the `data` property
        watch: {
            saved: function() {
                localStorage.setItem('saved', JSON.stringify(this.saved));
            },
            query: function() { return this.search(); },
            'cnf.staging': function() { return this.search(); },
            'cnf.approx': function() { return this.search(); },
            'cnf.onCountry': function() { return this.search(); },
            'cnf.country': function() { return this.search(); },
            'cnf.countries': function() { return this.search(); },
            'cnf.onType': function() { return this.search(); },
            // 'cnf.type': function() { return this.search(); },
            'cnf.types': function() { return this.search(); },
            'cnf.onProximity': function() { return this.search(); },
            'cnf.proximity': function() { return this.search(); },
            'cnf.onLimit': function() { return this.search(); },
            'cnf.limit': function() { return this.search(); },
            'cnf.autocomplete': function() { return this.search(); },
            'cnf.onLanguage': function() { return this.search(); },
            'cnf.language': function() { return this.search(); },
            'cnf.onCategories': function() { return this.search(); },
            'cnf.category': function() { return this.search(); },
            'cnf.languageStrict': function() { return this.search(); },
            'cnf.routing': function() { return this.search(); },
            'cnf.localsearch': function() { return this.search(); }
        },
        // methods functions perform CRUD operations on the `data` property
        methods: {
            help: function(url = 'https://docs.mapbox.com/api/search/#forward-geocoding') {
                window.open(url, '_blank');
            },
            setStyle: function(style) {
                this.map.setStyle(style);
            },
            setMarkers: function(src, data) {
                const markerSource = this.map.getSource(src);

                if (markerSource){
                    markerSource.setData(data);
                }
            },
            clearMarkers: function(src) {
                this.map.getSource(src).setData({ "type": "FeatureCollection", "features": [] });
            },
            setLanguage: function(lang) {
                let langObj = this.languages.find(langObj => langObj.code == lang);
                langObj ? langObj : { code: 'en', name: 'English' };
                this.cnf.language = langObj;
                this.updateQueryString();
            },
            setCountry: function(country) {
                let countryObj = this.countries.find(countryObj => countryObj.code == country);
                countryObj ? countryObj : { code: 'AA', name: 'Any' };
                this.cnf.country = countryObj;
                this.updateQueryString();
            },

            setCategory: function(cat) {
                let catObj = this.categories.find(catObj => catObj.code == cat);
                catObj ? catObj : {};
                this.cnf.category = catObj;
                this.updateQueryString();
            },

            toggleSettingsPanel: function(open) {
                this.settingsPanelOpened = open;
            },

            countryFind: function(query) {
                if (!query.length) return;
                let xhr = new XMLHttpRequest(query);
                xhr.open('GET', `${this.credentials.production.url}/mapbox.places/${encodeURIComponent(query)}.json?types=country&access_token=${this.credentials.production.key}`);
                xhr.onload = () => {
                    this.countries.splice(0, this.countries.length);
                    this.jsonResponse = JSON.parse(xhr.responseText);
                    
                    for (let feat of this.jsonResponse.features) {
                        this.countries.push({
                            name: feat.place_name,
                            code: feat.properties.short_code
                        });
                    }
                }
                xhr.send();
            },
            fetchCategories: function() {
                let xhr = new XMLHttpRequest();
                xhr.open('GET', `${this.credentials.production.listCategoriesUrl}?&language=en&access_token=${this.credentials.map.key}`);
                xhr.onload = () => {

                    this.jsonResponse = JSON.parse(xhr.responseText);

                    this.categories = this.jsonResponse.listItems.map((category) => ({
                        code: category.canonical_id,
                        name: category.name
                    }));

                    this.categories.sort((a, b) => a.name.localeCompare(b.name));
                }
                xhr.send();
            },
            showCategoryDropdown: function() {
                this.selectedCategory = undefined;
                this.categoryDropdownShown = true;
                this.$nextTick(() => {
                    const multiselect = document.querySelector('.hot-categories-container .multiselect__input');
                    multiselect.focus();
                });
            },

            updateQueryString: function() {
                // Update URL search
                // let cnf = Object.keys(this.cnf).map(key => {
                //     //console.log(key)
                //   return (key === 'language') ? `${key}=${this.cnf[key].code}` : `${key}=${this.cnf[key]}`;

                // }).join('&');
                // // Add query to string
                // if (this.query) {
                //   cnf = `${cnf}&query=${this.query}`
                // };
                // window.history.replaceState( {} , '/?', `?${cnf}` );
                let cnf = JSON.parse(JSON.stringify(this.cnf));
                cnf.query = this.query;

                window.location.hash = JSON.stringify(cnf);
            },
            handleResponseFeatures: function(features) {
                const annotatedFeatures = [...features];

                if(this.selectedCategory) {
                    annotatedFeatures.forEach((feature, idx) => feature.properties.lower_id = idx + 1);
                }
                
                this.geocoderResults.features = [...annotatedFeatures];

                this.suggestResults = features.map((feat, idx) => ({
                    ...feat,
                    name: feat.properties.name,
                    description: feat.properties.place_formatted,
                    id: feat.properties.mapbox_id,
                    lower_id: this.selectedCategory ? idx + 1 : undefined
                }));

                this.setMarkers('selected', this.toFeatureCollection(this.geocoderResults.features));

                // If single result, jump to
                if (this.geocoderResults.features.length === 1) {
                    let type = this.geocoderResults.features[0].properties.feature_type;

                    let max = this.maxZoom(type);

                    this.map.jumpTo({
                        center: this.geocoderResults.features[0].geometry.coordinates,
                        zoom: max
                    });

                } else {
                    this.map.fitBounds(turf.bbox(this.geocoderResults), {
                        animate: false,
                        padding: 250
                    });
                }
            },
            search: function() {
                let searchTime = new Date();
                this.updateQueryString();
                // this.updateBBOX();

                if (this.query.length === 0) return;

                let env = this.cnf.staging ? 'staging' : 'production';
                const tokenKey = this.cnf.localsearch ?  'key_hiero_federation' : 'key_federation';
                const  accessToken = this.cnf.onToken && this.cnf.token.length ? this.cnf.token : this.credentials[env][tokenKey];
                let url = '';
                const session_token = this.sessionId;

                if(this.selectedCategory?.name !== this.query) {
                    this.selectedCategory = undefined;
                }

                let endpoint;
                // check that endpoint is search API one
                if (!!(this.cnf.endpoint && this.cnf.endpoint.match(/\/search\/v\d\/[^/]+\/?$/gmi))) {
                    endpoint = this.cnf.endpoint.trim().replace(/\/$/, '');
                } else {
                    // check that query is expected to be reverse geocoding
                    if (/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/gmi.test(this.query)) {
                        endpoint = this.credentials[env].unifiedReverseUrl;
                    } else if(this.selectedCategory) {
                        endpoint = this.credentials[env].unifiedCategoryUrl;
                    } else {
                        endpoint = this.credentials[env].unifiedSuggestUrl;
                    }
                }

                const endpointType = endpoint.match(/\/([^/]+)$/m)[1];
                if (endpointType === 'category') {
                    url = `${endpoint}/${encodeURIComponent(this.selectedCategory.code)}?access_token=${accessToken}`;
                } else if (endpointType === 'reverse') {
                    const spacesOrCommaRgx = /[\s,]+/;
                    const [longitude, latitude] = this.query.split(spacesOrCommaRgx).map((c) => parseFloat(c, 10));

                    url = `${endpoint}?longitude=${longitude}&latitude=${latitude}&access_token=${accessToken}`;
                } else {
                    url = `${endpoint}?q=${encodeURIComponent(this.query)}&access_token=${accessToken}&session_token=${session_token}`;
                }

                url = this.addSearchParameters(url, endpointType);

                // save to show in raw api request panel
                this.url = url;

                let xhr = new XMLHttpRequest();
                xhr.open('GET', this.url);
                xhr.onload = () => {
                    // compare the time the request was made to that of the previous receieved response
                    // to make sure a slow query doesn't overwrite the automcomplete display
                    if (this.searchTime <= searchTime) {
                        this.searchTime = searchTime;
                        this.geocoderResults.features = []; //Clear Results
                        this.suggestResults = []; //Clear Results


                        if (xhr.status < 200 || xhr.status > 299) {
                            //TODO ERROR HANDLING
                        } else {
                            const response = JSON.parse(xhr.responseText);

                            this.jsonResponse = response;

                            if (response.suggestions) {
                                this.suggestResults = response.suggestions.map((s, idx) => ({
                                    ...s,
                                    description: s.place_formatted,
                                    lower_id: this.selectedCategory ? idx + 1 : undefined
                                }));
                            }

                            if (response.features) {
                                this.handleResponseFeatures(response.features);
                            }
                        }
                    }
                }
                xhr.send();

            },
            addSearchParameters: function(url, endpointType) {
                const language = this.cnf.onLanguage && this.cnf.language ? this.cnf.language.code : 'en';
                url = `${url}&language=${encodeURIComponent(language)}`;

                if (this.cnf.onCountry && this.cnf.country && this.cnf.country.code !== 'AA') url = `${url}&country=${encodeURIComponent(this.cnf.country.code)}`;
                if (this.cnf.onLimit && this.cnf.limit) url=`${url}&limit=${encodeURIComponent(this.cnf.limit)}`;

                if(endpointType !== 'category') {
                    if (this.cnf.onType && this.cnf.types.length) url = `${url}&types=${encodeURIComponent(this.cnf.types)}`;
                }

                if(endpointType !== 'category' && endpointType !== 'reverse') {
                    if (this.cnf.onCategories && this.cnf.categories) {
                        let catData = [];
                        this.cnf.categories.forEach (cat => {
                            catData.push(cat.code)
                        })
                        url = `${url}&poi_category=${encodeURIComponent(catData.join(','))}`;
                    }
                }

                if (endpointType !== 'reverse') {
                    if (this.cnf.onProximity && this.cnf.proximity) url = `${url}&proximity=${encodeURIComponent(this.cnf.proximity)}`;
                    if (this.cnf.origin) url=`${url}&origin=${encodeURIComponent(this.cnf.origin)}`;
                    if (this.cnf.navigationProfile) url=`${url}&navigation_profile=${encodeURIComponent(this.cnf.navigationProfile)}`;
                    if (this.cnf.etaType) url=`${url}&eta_type=${encodeURIComponent(this.cnf.etaType)}`;
                    if (this.cnf.bbox) url=`${url}&bbox=${encodeURIComponent(this.cnf.bbox)}`;
                    if (this.cnf.countries) url=`${url}&country=${encodeURIComponent(this.cnf.countries)}`;
                    if (this.cnf.route) url=`${url}&route=${encodeURIComponent(this.cnf.route)}`;
                    if (this.cnf.sarType) url=`${url}&sar_type=${encodeURIComponent(this.cnf.sarType)}`;
                    if (this.cnf.timeDeviation) url=`${url}&time_deviation=${encodeURIComponent(this.cnf.timeDeviation)}`;
                    if (this.cnf.cpsParkingType) url=`${url}&cps_parking_type=${encodeURIComponent(this.cnf.cpsParkingType)}`;
                    if (this.cnf.cpsTimePeriod) url=`${url}&cps_time_period=${encodeURIComponent(this.cnf.cpsTimePeriod)}`;
                }
                return url;
            },
            searchClear: function(e) {
                this.query = '';
                this.selectedCategory = undefined;
                this.categoryDropdownShown = false;
                this.suggestResults = [];
                this.geocoderResults.features = [];
                this.cnf.subType = null;
                this.sessionId = uuidv4();
            },
            searchFocus: function(e) {
                this.cnf.subType = null;
                if (this.query.length === 0) {
                    this.geocoderResults.features = this.saved.map((save, it) => {
                        return {
                            id: 'saved',
                            place_name: save,
                            properties: {
                                maki: 'rocket'
                            }
                        }
                    }).reverse();
                }
            },
            shareClick: function(e) {
                window.open(this.url, '_newtab');
            },
            // typeClick: function(e) {
            //     let searchType = e.target.value;
            //     // this.cnf.typeToggle[type] = !this.cnf.typeToggle[type];
            //     // this.cnf.type = searchType;
            //     // this.cnf.subType = null;
            //     // this.searchClear();
            // },
            typeClick: function(e) {

                let type = e.target.getAttribute('type');
                this.cnf.typeToggle[type] = !this.cnf.typeToggle[type];
                if (this.cnf.types.indexOf(type) === -1) this.cnf.types.push(type);
                else this.cnf.types.splice(this.cnf.types.indexOf(type), 1);
            },
            hotButtonCategoryClick: function(category) {
                this.categoryDropdownShown = false;
                this.handleSelectCategory(category);
            },
            handleSelectCategory: function(category) {
                this.selectedCategory = category;
                this.query = this.selectedCategory.name;
            },
            // typeClearAll: function(e) {
            //     for (let typeName in this.cnf.typeToggle) {
            //         this.cnf.typeToggle[typeName] = false;
            //     }
            //     this.cnf.types = [];
            // },
            // typeAddAll: function(e) {
            //     for (let typeName in this.cnf.typeToggle) {
            //         this.cnf.typeToggle[typeName] = true;
            //         if (this.cnf.types.indexOf(typeName) === -1) this.cnf.types.push(typeName);
            //     }
            // },
            setCurrentPositionProximity: function(e) {
                navigator.geolocation.getCurrentPosition((pos) => {
                    let coords = `${pos.coords.longitude},${pos.coords.latitude}`;
                    this.cnf.proximity = coords;
                    this.setProximity();
                }, (err) => {
                    this.setProximity();
                });
            },
            setProximity: function(e) {
                this.cnf.proximity = this.cnf.proximity ? this.cnf.proximity : '-98, 40';
                let zoom = (this.cnf.proximity === '-98, 40') ? 3 : 13;
                this.map.jumpTo({
                    center: this.cnf.proximity.split(',').map(Number),
                    zoom: zoom
                });
                this.proximityMarker = new mapboxgl.Marker({
                    draggable: true
                }).setLngLat(this.cnf.proximity.split(',').map(Number)).addTo(this.map);
                this.proximityMarker.on('dragend', this.proximityDrag);
            },
            proximityClick: function(e) {
                this.setCurrentPositionProximity();
            },
            proximityManualClick: function(e) {
                this.map.jumpTo({
                    center: this.cnf.proximity.split(',').map(Number),
                    zoom: 13
                });
            },
            proximityDrag: function(e) {
                let lngLat = this.proximityMarker.getLngLat();
                this.cnf.proximity = `${lngLat.lng.toFixed(6)},${lngLat.lat.toFixed(6)}`;
            },
            catClick: function(e) {
                this.query = e.target.getAttribute('type');
                this.cnf.subType = 'search';
            },

            enterKeySearch: function(e) {
                const isEnterKey = e.keyCode === 13;
                this.selectedCategory = undefined;
                this.categoryDropdownShown = false;

                if (isEnterKey) {
                    let item = this.suggestResults[0];
                    if (!item) {
                        return;
                    }

                    this.handleSelection(item);
                }
            },
            resultEnter: function(e) {
                let res = parseInt(e.target.getAttribute('result'));
            },
            resultLeave: function(e) {
                this.clearMarkers('hovered-bbox');
                this.clearMarkers('hovered');
            },
            handleSelection(item) {
                // if a feature includes geographic coordinates it's returned from /retrieve endpoint
                // https://docs.mapbox.com/api/search/search-box/#retrieve-a-suggested-feature
                if (item.geometry?.coordinates) {
                    let type = item.properties.feature_type;

                    let max = this.maxZoom(type);

                    this.map.jumpTo({
                        center: item.geometry.coordinates,
                        zoom: max
                    });
                }
                // If feature does not include geographic coordinates, get coordinates making a call to the /retrieve endpoint with the mapbox_id provided in the /suggest result.
                // https://docs.mapbox.com/api/search/search-box/#response-get-suggested-results
                else {
                    let env = this.cnf.staging ? 'staging' : 'production';
                    const tokenKey = this.cnf.localsearch ?  'key_hiero_federation' : 'key_federation';
                    const accessToken = this.cnf.onToken && this.cnf.token.length ? this.cnf.token : this.credentials[env][tokenKey];
                    const session_token = this.sessionId;

                    let xhr = new XMLHttpRequest();

                    const isCategory = item.feature_type === "category";

                    let url;
                    
                    if(isCategory) {
                        const categoryId = item.poi_category_ids?.[0];
                        this.selectedCategory = { name:item.name, code: categoryId };
                        url = `${this.credentials[env].unifiedCategoryUrl}/${categoryId}?access_token=${accessToken}`;
                        url = this.addSearchParameters(url, 'category');
                    }else {
                        url = `${this.credentials[env].unifiedRetrieveUrl}/${item.mapbox_id}?access_token=${accessToken}&session_token=${session_token}`;
                    }

                    // save to show in raw api request panel
                    this.url = url;

                    xhr.open('GET', url, true);
                    xhr.onload = () => {

                        this.geocoderResults.features = []; // clear results
                        this.suggestResults = []; // clear results
                        this.sessionId = uuidv4(); // Reset session ID

                        if (xhr.status < 200 || xhr.status > 299) {
                            //TODO ERROR HANDLING
                        } else {
                            this.jsonResponse = JSON.parse(xhr.responseText);
                            this.handleResponseFeatures(this.jsonResponse.features);
                        }
                    }
                    xhr.send();
                }
            },
            resultClick: function(e) {
                let res = parseInt(e.target.getAttribute('result'));
                let item = this.suggestResults[res];

                this.handleSelection(item);
            },
            hecate: function(e) {
                const win = window.open(`https://hecate-internal-prod-us.tilestream.net/admin/index.html#${this.map.getZoom()}/${this.map.getCenter().lat}/${this.map.getCenter().lng}`, '_blank').focus();
            },
            josm: function(e) {
                let ne = this.map.getBounds().getNorthEast().wrap().toArray();
                let sw = this.map.getBounds().getSouthWest().wrap().toArray();

                let xhr = new XMLHttpRequest();
                xhr.open('GET', `http://127.0.0.1:8111/load_and_zoom?left=${sw[0]}&right=${ne[0]}&top=${ne[1]}&bottom=${sw[1]}`);
                xhr.send();
            },
            bugReport: (e) => {
                window.open('https://github.com/mapbox/search-playground/issues/new');
            },
            toFeatureCollection: function(feature) {
                const routable_points = feature.properties?.coordinates?.routable_points;

                if (routable_points?.length > 0) {
                    const routablePoint = turf.point([routable_points[0].longitude, routable_points[0].latitude]);
                    return turf.featureCollection([feature, routablePoint]);
                } else {
                    return turf.featureCollection([feature]);
                }
            },
            maxZoom: function(type) {
                let max = 16;
                if (type === "street") max = 15;
                else if (type === "locality") max = 14;
                else if (type === "place" || type === "city") max = 13;
                else if (type === "district") max = 9;
                else if (type === "region") max = 6;
                else if (type === "country") max = 4;

                return max;
            }
        }
    });
}
